export default {
  mobile:  '(max-width: 600px)',
  tablet:  '(min-width: 992px) and (max-width: 1200px)',
  desktop: '(min-width: 1201px)',

  searchMobile: '(max-width: 767px)',
  searchTablet: '(min-width: 768px) and (max-width: 1023px)',
  searchDesktop: '(min-width: 1024px)',

  medium: '(min-width: 601px) and (max-width: 1019px)',
  mediumAndDown: '(max-width: 1019px)',
  mediumAndUp: '(min-width: 601px)',
  largeAndUp: '(min-width: 1020px)',

  // special case for size at which dashboard no longer has overlap issues
  dashboardLargeAndUpCompressedBound: '(max-width: 1120px)',
};
